/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Status_EnabledInputs */

const id_reseller_pricing_status_enabled = /** @type {(inputs: Reseller_Pricing_Status_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif`)
};

const en_reseller_pricing_status_enabled = /** @type {(inputs: Reseller_Pricing_Status_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On sale`)
};

/**
* | output |
* | --- |
* | "On sale" |
*
* @param {Reseller_Pricing_Status_EnabledInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_status_enabled = /** @type {((inputs?: Reseller_Pricing_Status_EnabledInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Status_EnabledInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_status_enabled(inputs)
	return id_reseller_pricing_status_enabled(inputs)
});